import { Component } from 'react';
import classnames from 'classnames';
import classNames from 'classnames/bind';
import ArrowLink from 'components/atoms/arrowLink';

import styles from './styles.scss';

let cx = classNames.bind(styles);

export default class Modal extends Component {
  render() {
    const { open, onClose } = this.props;
    let className = cx({
      modal: true,
      'modal-open': open,
    });

    return (
      <div className={classnames(className)}>
        <div className="modalContainer">
          <div className="modalBody">
            {this.props.children}
            <div className="modalClose">
              <ArrowLink size="small" onClick={onClose}>
                Cerrar
              </ArrowLink>
            </div>
          </div>
        </div>
        <div className="modalOverlay" />
      </div>
    );
  }
}
